import { useMemo } from 'react';
import maxBy from 'lodash/maxBy';
export const useMaxValue = (readings)=>useMemo(()=>{
        const maxReading = maxBy(readings, 'value');
        return maxReading ? maxReading.value : 0;
    }, [
        readings
    ]);
